import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Functions, httpsCallable } from '@angular/fire/functions';
import { TranslateService } from '@ngx-translate/core';

import { environment } from '../../environments/environment';

@Component({
    selector: 'app-customer',
    templateUrl: `./customer.component${environment.componentAssetExt}.html`,
    styleUrl: `./customer.component${environment.componentAssetExt}.scss`,
    standalone: false
})
export class CustomerComponent implements OnInit {

  email = '';
  name = '';
  taxId = '';
  country = '';
  postalCode = '';
  city = '';
  address = '';

  giveMoreData = false;
  inProgress = false;

  private sessionId = '';

  constructor(
    private functions: Functions,
    private route: ActivatedRoute,
    private router: Router,
    translate: TranslateService
  ) {
    translate.use(translate.getBrowserLang() ?? translate.getFallbackLang() ?? 'en');
  }

  async ngOnInit() {
    const sid = this.route.snapshot.paramMap.get('sid');
    if (sid === null) return;
    this.sessionId = sid;
  }

  async storeCustomerData() {
    this.inProgress = true;
    await httpsCallable(this.functions, 'storeCustomerData')({
      instanceId: environment.instanceId,
      sessionId: this.sessionId,
      email: this.email,
      name: this.name,
      taxId: this.taxId,
      country: this.country,
      postalCode: this.postalCode,
      city: this.city,
      address: this.address,
    }).then(() => this.router.navigate(['payment-init', this.sessionId])
    ).catch(console.error);
    this.inProgress = false;
  }
}
